import { createContext, useContext } from 'react'
import {
  PALETTES,
  CHART_PALETTES,
  type Palette,
  type ThemeMode,
  type Hex,
} from '@/theme/tokens'
import type { ThemePreference } from '@/theme/preference'

export interface ThemeContextValue {
  preference: ThemePreference
  mode: ThemeMode
  palette: Palette
  chartPalette: readonly Hex[]
  storageAvailable: boolean
  setPreference: (preference: ThemePreference) => void
}

// Defaults keep isolated consumers usable in stories and existing component tests.
export const ThemeContext = createContext<ThemeContextValue>({
  preference: 'dark',
  mode: 'dark',
  palette: PALETTES.dark,
  chartPalette: CHART_PALETTES.dark,
  storageAvailable: true,
  setPreference: () => {},
})

export function useThemePreference(): ThemeContextValue {
  return useContext(ThemeContext)
}
